import { AfterViewInit, Directive, Input } from '@angular/core';
import { LcsMultiSelectComponent } from '@lcs/shared/multi-select';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';
import { UserMultiSelectDataSource } from './user-multi-select-data-source';

@Directive({
    selector: 'lcs-multi-select[ndtUserMultiSelect]',
    standalone: false
})
export class UserMultiSelectDirective implements AfterViewInit {
   @Input() accountId: number | null;

   constructor(private multiSelect: LcsMultiSelectComponent<UserOption>, private store: Store<AppState>) {
      this.multiSelect.data = new UserMultiSelectDataSource(this.store, []);
      this.multiSelect.displayWith = (item: UserOption | null) => {
         return item ? `${item.name}` : null;
      };
   }

   ngAfterViewInit(): void {
      const staticFilterOverride: string[] = [];

      if (this.accountId) {
         staticFilterOverride.push(`AccountId = ${this.accountId}`);
      }

      // This is being set twice because the lcs shared component we're using for some reason only checks the validity of the selectAll button's existence once
      this.multiSelect.data = new UserMultiSelectDataSource(this.store, staticFilterOverride);
   }
}
